module.exports = __webpack_public_path__ + "static/img/OOSH_002.868a08d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_002.jpg
// module id = qi3i
// module chunks = 170